import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const dataFormatter = new Jsona();

export default {
    async getSupplyTypes(params) {
        const response = await axios.get(API_URL + "/supplytypes", { headers: authHeader(), params: params });
        return { data: dataFormatter.deserialize(response.data), meta: response.data.meta?.page };
    },

    async addSupplyType(supplytype) {
        supplytype.type = "supplytypes"
        const newJson = dataFormatter.serialize({ stuff: supplytype })
        const response = await axios.post(API_URL + "/supplytypes", newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async deleteSupplyType(supplytypeId) {
        await axios.delete(API_URL + "/supplytypes/" + supplytypeId, { headers: authHeader() });
    },

    async getSupplyType(supplytypeId) {
        const response = await axios.get(API_URL + "/supplytypes/" + supplytypeId, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async editSupplyType(supplytype) {
        supplytype.type = "supplytypes"
        const newJson = dataFormatter.serialize({ stuff: supplytype })
        const response = await axios.patch(API_URL + "/supplytypes/" + supplytype.id, newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },
}




